import React from "react";
import { Badge } from "./ui/badge";
import { MapPin, Navigation } from "lucide-react";
import { serviceAreas, businessInfo } from "../data/mock";

const ServiceAreas = () => {
  return (
    <section id="service-areas" className="py-20 md:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Badge className="bg-green-50 text-green-700 border border-green-200 hover:bg-green-50 mb-4">Service Areas</Badge>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight">Proudly serving all of <span className="text-green-600">Marin County</span></h2>
            <p className="text-slate-600 mt-4 text-lg">
              Wherever you're searching “smog check near me” from in Marin County or southern Sonoma, Hamilton's is a short, worthwhile drive to Novato. Two bays and fast turnaround make the trip easy.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              {serviceAreas.map((a) => (
                <div key={a.name} className="flex items-start gap-3 p-3 rounded-lg bg-white border border-slate-200 card-hover">
                  <div className="w-9 h-9 rounded-md bg-slate-900 grid place-items-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-green-500" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 text-sm">{a.name}</div>
                    <div className="text-xs text-slate-500">{a.distance} • {a.zip}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden shadow-xl border border-slate-200 bg-white">
            <iframe
              title="Hamilton's Smog Location Map"
              src="https://www.google.com/maps?q=1032+First+St,+Novato,+CA+94945&output=embed"
              width="100%"
              height="460"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="p-5 border-t border-slate-200 flex items-center justify-between">
              <div>
                <div className="font-black text-slate-900">{businessInfo.name}</div>
                <div className="text-sm text-slate-500">{businessInfo.address}</div>
              </div>
              <a
                href={businessInfo.directionsUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-green-600 font-bold text-sm hover:text-green-700"
              >
                <Navigation className="w-4 h-4" /> Get Directions
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
